<template>
    <div class="plans-container">
        <AppBreadCrumb :paths="[{ title: 'Plan Managments' }]" :select="true">
            <a-button class="actionButtonBreadcrumb" @click="modalShowing = true">
                <span class="material-icons"> add </span>Oluştur
            </a-button>
        </AppBreadCrumb>
        <a-modal :visible="deleteItem" icon="exclamation-circle" :title="'Delete Package'" @cancel="deleteItem = null">
            <p>Bu paketi silmek istediğinizden eminmisiniz kalıcı olarak silinecektir.</p>
            <template #footer>
                <a-button key="back" @click="deleteItem = null">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deletePackage">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
        <CreateNewPlanModal
            v-if="modalShowing"
            v-model="form"
            @cancel="modalShowing = false"
            @create="createNewPlan"
            @update="planUpdate"
        />

        <div class="plan-container breadcrumb-content">
            <div class="sidebar">
                <PlanMenu v-model="currentTab" :types="Object.keys(plans)" />
            </div>
            <div class="plan-container-content">
                <div
                    v-if="!Object.keys(plans).length"
                    style="display: flex; align-items: center; justify-content: center; height: 80%"
                >
                    <div style="display: flex; align-items: center; flex-direction: column">
                        <span class="material-icons" style="font-size: 150px"> sentiment_very_dissatisfied </span>
                        <div style="font-weight: bold; font-size: 26px">
                            Bakıyorum da ortalıkta hiç oluşturulmuş paket yok. Oluşturmak istermisin?
                        </div>
                        <div
                            style="
                                background: rgb(236, 75, 29);
                                color: white;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                padding: 10px 15px;
                                border-radius: 100px;
                                user-select: none;
                                cursor: pointer;
                                margin-top: 20px;
                            "
                            @click="planSeed"
                        >
                            Paketleri Tanımla
                        </div>
                    </div>
                </div>
                <div v-else class="plan" v-for="planName of Object.keys(plans).filter((type) => type === currentTab)">
                    <div class="plan-title">
                        {{
                            planName
                                .split("-")
                                .map((c) => c[0].toUpperCase() + c.slice(1).toLowerCase())
                                .join(" ")
                        }}
                        Paketleri
                    </div>
                    <div class="content">
                        <transition name="scale">
                            <button
                                @click="previousPlan"
                                :class="{ 'scale-in': prevButton, 'scale-out': !prevButton }"
                                id="prev-button"
                                v-show="plans[planName].length > 4 && prevButton"
                            >
                                <md-icon class="navigate-arrow navigate-left">arrow_back_ios_new</md-icon>
                            </button>
                        </transition>
                        <div class="items" ref="plansContainer">
                            <Card
                                v-for="item of plans[planName]"
                                :key="item._id"
                                :plan="item"
                                @edit-action="editPlan(item)"
                                @delete-action="deleteItem = item"
                                :editable-card="true"
                                :details="{ agentCount: 1, whatsappChannel: 1 }"
                                class="plan-card"
                            />
                        </div>
                        <transition name="scale">
                            <button
                                @click="nextPlan"
                                :class="{ 'scale-in': nextButton, 'scale-out': !nextButton }"
                                id="next-button"
                                v-show="plans[planName].length > 4 && nextButton"
                            >
                                <md-icon class="navigate-arrow navigate-right">arrow_forward_ios</md-icon>
                            </button>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import * as _ from "lodash";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import { createPlan, deletePlan, getDefaultPlans, updatePlan } from "../../../api/site";
import CreateNewPlanModal from "../../../components/billing/CreateNewPlanModal.vue";
import Card from "../../../components/billing/Card.vue";
import request from "../../../utils/request";
import PlanMenu from "./PlanMenu.vue";

const log = log2("SupsisPlans");
export default {
    name: "SupsisPlans",
    components: {
        AppBreadCrumb,
        CreateNewPlanModal,
        Card,
        PlanMenu,
    },
    props: {
        siteId: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        period: "annual",
        modalShowing: false,
        editingPlan: false,
        deleteItem: null,
        form: null,
        featuresPricingForm: null,
        featuresForm: null,
        plans: {},
        currentTab: "supsis",
        prevButton: false,
        nextButton: true,
    }),
    computed: {
        ...mapState({
            adminUser: (state) => state.user.adminUser,
            loggedUser: (state) => state.auth.adminUser,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
    },
    methods: {
        async deletePackage() {
            await deletePlan(this.deleteItem._id);
            const type = this.deleteItem.type;
            this.plans[type] = this.plans[type].filter((p) => p._id !== this.deleteItem._id);
            this.deleteItem = null;
        },
        calculateSlider() {
            this.$nextTick(() => {
                const container = document.querySelector(".items");
                if (!container) {
                    console.error("plansContainer ref is not defined.");
                    return;
                }
                this.listener = (e) => {
                    console.log("eee", e);
                    const target = e.target;
                    if (target.scrollLeft <= 100) {
                        this.prevButton = false;
                        this.nextButton = true;
                    } else if (target.scrollLeft + 0.5 >= target.scrollWidth - target.clientWidth) {
                        this.nextButton = false;
                        this.prevButton = true;
                    } else {
                        this.prevButton = true;
                        this.nextButton = true;
                    }
                };

                container?.addEventListener("scroll", this.listener);
            });
        },
        resetSlider() {
            const element = document.querySelector(".items");
            element.style.scrollBehavior = "auto";
            element.scrollLeft = 0;
            element.style.scrollBehavior = "smooth";
        },
        nextPlan() {
            const element = document.querySelector(".items");
            element.scrollBy(700, 0);
        },
        previousPlan() {
            const element = document.querySelector(".items");
            element.scrollBy(-700, 0);
        },
        createNewPlan(form) {
            createPlan(form).then((newPlan) => {
                const type = newPlan.type;
                if (!this.plans[type]) this.plans[type] = [];
                this.plans[type] = [...this.plans[type], newPlan];
                this.modalShowing = false;
                this.$notification.success({
                    message: "Plan Oluşturuldu",
                    description: "Plan başarılı bir şekilde oluşturuldu.",
                });
            });
        },
        planUpdate(form) {
            updatePlan(form._id, form).then((plan) => {
                const newPlanType = plan.dynamicType || plan.type;
                const editedPlanType = form.dynamicType || form.type;
                const type = newPlanType === editedPlanType ? newPlanType : editedPlanType;
                this.plans[type] = (this.plans[type] || []).map((p) => {
                    if (p._id === plan._id) p = plan;
                    return p;
                });
                this.modalShowing = false;
                this.$notification.success({
                    message: "Plan Güncellendi",
                    description: "Plan başarılı bir şekilde güncellendi.",
                });
            });
        },
        editPlan(plan) {
            this.form = { ...plan };
            this.modalShowing = true;
        },
        planSeed() {
            request.post(`plans/seed-start`).then(this.getPlans);
        },
        getPlans() {
            getDefaultPlans().then((plans) => {
                this.plans = _.groupBy(
                    plans.filter((plan) => !plan.isDeleted),
                    (p) => p.type
                );
            });
        },
    },
    beforeMount() {
        const isAccessEnabled =
            this.loggedUser.isFullAccess ||
            this.loggedUser.approvedPages.some((page) => page.page === "plan-management");
        if (!isAccessEnabled) {
            this.$router.push("/denied");
        }
    },
    watch: {
        modalShowing(newVal) {
            if (!newVal) {
                this.form = null;
            }
        },
        currentTab() {
            this.resetSlider();
        },
    },
    beforeUpdate() {
        this.calculateSlider();
    },
    beforeDestroy() {
        const element = document.querySelector(".items");
        if (element) {
            element.removeEventListener("scroll", this.listener);
        }
    },
    mounted() {
        log("mounted", this.plans);
        this.getPlans();
    },
};
</script>
<style lang="scss">
.plans-container {
    .plan-container {
        .items {
            max-width: 65vw;
            display: flex;
            overflow: auto !important;
            gap: 28px;
            padding: 35px;
            scroll-behavior: smooth;
            &::-webkit-scrollbar {
                display: none;
            }
            .plan-card {
                min-width: 18vw !important;
            }
            :last-child {
                margin-right: 0;
            }
        }
        .content {
            .navigate-arrow {
                color: white !important;
                font-size: 24px !important;
                font-weight: 800 !important;
            }
            #prev-button {
                position: absolute;
                left: 15px;
                top: 50%;
                z-index: 99999;
                height: 60px;
                width: 60px;
                border-radius: 50%;
                background-color: rgb(236, 75, 29) !important;
                border: none;
                .navigate-left {
                    margin-right: 2px !important;
                }
            }
            #next-button {
                position: absolute;
                right: 15px;
                top: 50%;
                z-index: 99999;
                height: 60px;
                width: 60px;
                border-radius: 50%;
                background-color: rgb(236, 75, 29) !important;
                border: none;
                .navigate-right {
                    margin-left: 2px !important;
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.plans-container {
    height: calc(100vh - 47px - 55px) !important;
    .sidebar {
        height: 100%;
    }
    .plan-container {
        display: flex;
        gap: 10px;
        height: 100%;

        .plan-container-content {
            width: 100%;
            padding: 40px;
            overflow-y: auto !important;
            border: none !important;
            min-height: auto !important;
            position: relative;
            overflow-x: hidden;
        }

        .plan-title {
            font-size: 28px;
            font-weight: bold;
            margin-bottom: 10px;
            color: #171725;
        }
    }

    .top-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
}
</style>
